import { useMemo } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { useStyles } from './styles';
import { useTranslation } from 'react-i18next';

export const Locations = ({ locations }) => {
  const { t } = useTranslation()
  const styles = useStyles();

  const mappedLocations = useMemo(() => {
    if (!locations) {
      return [];
    }

    const filteredLocations = locations.filter((location) => !!location.name)

    return _.sortBy(filteredLocations, 'id')
  }, [locations])

  if(!locations || !locations.length) {
    return null;
  }

  return (
    <div className={styles.container}>
      <div className={styles.title}>
        {t('Locations')}
      </div>

      {mappedLocations.map((location) => (
        <a
          className={styles.locationLink}
          href={`http://maps.google.com/?q=${location.latitude},${location.longitude}`}
          target="_blank"
          rel="noopener noreferrer"
          key={location.id}
        >
          <div className={styles.locationTitle}>
            {location.name}
          </div>
          <div>{location.address.street ? location.address.street : null}</div>
          <div>{location.address.street2 ? location.address.street2 : null}</div>
          <div>
            {location.address.city ? location.address.city + ', ' : null}
            {location.address.country ? location.address.country + ' ' : null}
            {location.address.postalCode ? location.address.postalCode : null}
          </div>
        </a>
      ))}
    </div>
  );

};

Locations.propTypes = {
  locations: PropTypes.object,
};
